import React, { Component } from 'react'
import '../_ie.scss'

const Intro = () => (
  <div className="ie intro">
    <div className="ie intro_header">
      <h2>CetraRuddy DNA</h2>
    </div>
    <div className="ie intro_header">
      <h2>6 Stories</h2>
    </div>
    <div className="ie intro_header">
      <h2 className="ie yellow">1 Vision</h2>
    </div>
  </div>
)
export default Intro



// WEBPACK FOOTER //
// ./src/components/explorer/intro/index.js